import { gql } from "@apollo/client";

export const FIELD_REGISTRY = gql`
  query FieldRegistry($process: ProcessWhereInput) {
    fieldRegistry(process: $process) {
      key
      collection
      fields {
        key
        label
        options
        target
        mode
        type
        required
        defaultRules
        inputConfig
        scoped
      }
    }
  }
`;

export const COMPUTE_FIELD = gql`
  query ComputeField(
    $project: ProjectDataInput!
    $key: String!
    $args: JSONObject
  ) {
    computeField(project: $project, key: $key, args: $args)
  }
`;

export const EXECUTE_FIELD = gql`
  mutation ExecuteField(
    $key: String!
    $entity: EntityInput!
    $args: JSONObject
  ) {
    executeField(key: $key, entity: $entity, args: $args)
  }
`;

const fieldRegistry = { FIELD_REGISTRY, COMPUTE_FIELD, EXECUTE_FIELD };

export default fieldRegistry;
